import { PageHeader } from "@/components/common";

const content = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect only the information needed to process your ticket bookings — your name, mobile number and optional email.",
      "Payment information is handled securely by our payment partner (Razorpay). We do not store your card details.",
      "We do not sell or share your personal data with third parties except as required to deliver your tickets or by law.",
      "For any privacy requests, contact hello@sirakhcreations.com.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "Tickets are valid only for the specified event, date and venue.",
      "Each ticket admits the stated number of guests and is validated via QR code at entry.",
      "A ticket once scanned and marked as used cannot be reused.",
      "Sirakh Creations reserves the right to refuse entry in case of invalid or duplicate tickets.",
      "Event details may change; we will notify ticket holders of major changes where possible.",
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      "All ticket sales are final unless an event is cancelled by the organiser.",
      "If an event is cancelled, ticket holders will be refunded the ticket amount via the original payment method.",
      "Rescheduled events: existing tickets remain valid for the new date.",
      "For refund queries, contact hello@sirakhcreations.com with your Booking ID.",
    ],
  },
};

export default function PolicyPage({ type }) {
  const data = content[type];
  return (
    <div data-testid={`policy-${type}`}>
      <PageHeader caption="Legal" title={data.title} />
      <div className="mx-auto max-w-3xl px-4 pb-10 sm:px-8">
        <div className="card-dark space-y-4 p-8 text-zinc-300">
          {data.body.map((p, i) => <p key={i} className="leading-relaxed">{p}</p>)}
        </div>
      </div>
    </div>
  );
}
